import * as Yup from 'yup';
import { IDateTypeControlField } from '../types/date-field';

export default function dateTypeFieldValidation(field: IDateTypeControlField) {
  let schema = Yup.array().nullable();
  if (field.is_mandatory) {
    schema = schema.required('This field is required').test({
      test: (value) => {
        if (Array.isArray(value) && value.length === 2) {
          return true;
        }
        return false;
      },
      message: 'This is required'
    });
  }
  return {
    [field.name]: schema
  };
}
